var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResults({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8079;}\n\t.st1{fill:#B9CFC0;}\n\t.st2{fill:#2A384F;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#EFC15D;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:8.4053;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 141.6,
    cy: 141.4,
    r: 109.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 141.6,
    cy: 67.8,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.4,214.8h-79.6c-6.4,0-11.5-5.2-11.5-11.5V94.5c0-6.4,5.2-11.5,11.5-11.5h79.6c6.4,0,11.5,5.2,11.5,11.5 v108.8C192.9,209.6,187.7,214.8,181.4,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.4,206.7h-73.7c-4.1,0-7.4-3.3-7.4-7.4V99.4c0-4.1,3.3-7.4,7.4-7.4h73.7c4.1,0,7.4,3.3,7.4,7.4v99.9 C185.9,203.4,182.5,206.7,178.4,206.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.1,
    y: 71.9,
    className: "st1",
    width: 62.9,
    height: 20.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 141.6,
    cy: 67.8,
    r: 6.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 141.6,
    cy: 149.2,
    r: 37.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "124.9,148.8 137.5,160.3 158.3,138.1  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/Results.8f774af423361039006c5e1e3a3f8a38.svg";
export { ForwardRef as ReactComponent };